import { db } from '../../sdk_initialization';
import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';

const COLLECTION = 'precheckins';

export const getPrecheckinDocId = (eventId, vendorId) => {
  const e = String(eventId || '').trim();
  const v = String(vendorId || '').trim();
  if (!e || !v) return '';
  return `${e}_${v}`;
};

export const getPrecheckin = async (eventId, vendorId) => {
  const id = getPrecheckinDocId(eventId, vendorId);
  if (!id) return null;

  const ref = doc(db, COLLECTION, id);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
};

export const upsertPrecheckin = async ({ eventId, vendorId, data, userUid }) => {
  const id = getPrecheckinDocId(eventId, vendorId);
  if (!id) throw new Error('Missing eventId or vendorId');

  const ref = doc(db, COLLECTION, id);
  const existing = await getDoc(ref);

  const payload = {
    ...(data || {}),
    eventId: String(eventId || '').trim(),
    vendorId: String(vendorId || '').trim(),
    updatedBy: userUid || null,
    updatedAt: serverTimestamp(),
  };

  if (!existing.exists()) {
    payload.createdBy = userUid || null;
    payload.createdAt = serverTimestamp();
  }

  await setDoc(ref, payload, { merge: true });
  const latest = await getDoc(ref);
  return latest.exists() ? { id: latest.id, ...latest.data() } : { id, ...payload };
};
